import RedirectMain from "./redirect/RedirectMain.tsx";
import { redirectAction, redirectLoader } from "./redirect/redirectApi.ts";
import { RedirectError } from "./redirect/RedirectError.tsx";

export const userRoutes = {
  children: [
    {
      path: "/redirect",
      element: <RedirectMain />,
      loader: redirectLoader,
      action: redirectAction,
      errorElement: <RedirectError />,
    },
  ],
};
